import { ApolloClient, InMemoryCache } from "@apollo/client";

export const client = new ApolloClient({
  uri:
    "https://api-eu-central-1.graphcms.com/v2/ckbsbndk001je01z76u8zhb2w/master",
  cache: new InMemoryCache(),
});
